import React from 'react';
import { site } from '../../configs/site';

// Four-step "How every migration runs" band (site.howItRuns). Shared by
// the home page and the platform pages.
const HowItRunsBand = ({ className = 'px-4 py-4 sm:px-6 lg:px-10' }) => {
  if (!site.howItRuns?.enabled) {
    return null;
  }

  return (
    <section className={className}>
      <div className="flex flex-col gap-5 rounded-xl bg-white p-7 shadow-sm ring-1 ring-inset ring-gray-200">
        <h3 className="text-xl font-bold text-gray-900">{site.howItRuns.title}</h3>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {site.howItRuns.steps.map((step, index) => (
            <div key={step.title} className="flex flex-col gap-1.5">
              <div className="text-xs font-semibold uppercase tracking-wider text-primary-600">
                Step {String(index + 1).padStart(2, '0')}
              </div>
              <div className="text-[15px] font-semibold text-gray-900">{step.title}</div>
              <div className="text-sm leading-normal text-gray-600">{step.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItRunsBand;
